import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import '@/index.css';

// Enable strict mode for better development experience
const StrictApp = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Mount the app
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(<StrictApp />);